// POM-6306: a catalog product disabled for ordering stays selectable wherever a user is working an
// order that already exists. Everything here is informational — it never blocks the action. Shared
// so every picker says the same thing.

// Chip text. Deliberately short: it sits beside the Product ID, and the chip's icon plus the
// tooltip below carry the rest without pushing the option row wider than an enabled one.
export const CATALOG_DISABLED_LABEL = 'Disabled';

export const CATALOG_DISABLED_TOOLTIP =
  'Disabled for new orders. It can still be associated to fulfil an order that already exists.';

// Shown once a disabled product is chosen in the drug-review association, where the choice also
// decides what happens to LATER orders for the same drug - so the note has to say so.
export const CATALOG_DISABLED_ASSOCIATION_NOTE =
  'You have selected a product that is disabled for new orders. It can still be associated to fulfil this order, and it will not be reused for orders placed from now on.';

// Multi-Rx resolve writes no reusable mapping, so the sentence above would be untrue there. All
// this note has to do is confirm the click was deliberate.
export const CATALOG_DISABLED_SELECTION_NOTE =
  'This product is disabled for new orders. Fulfilment is not blocked - this is only to confirm the choice.';
